<template>
  <b-form inline class="form-group" id="lang-toggler">
    <label class="mr-sm-2" for="lang-toggler">{{this.$t("langToggler.lang")}}:</label>
    <select
    id="lang-select"
    v-model="current"
    @change="setLang">
      <option
      v-for="(locale, index) in locales"
      :key="index">
        {{locale}}
      </option>
    </select>
  </b-form>
</template>

<script>
export default {
  data: function() {
    return {
      locales: [],
      current: ""
    }
  },
  created: function() {
    this.locales = this.$i18n.availableLocales;
    this.current = this.$i18n.locale;
  },
  methods: {
    setLang: function() {
      localStorage.setItem("lang", this.current);
      this.$store.commit("settings/SET_LANG", this.current)
      this.$i18n.locale = this.current;
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 0px;
}
</style>
